import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

const LoaderOverlay = ({ loading, children }) => (
  <div style={{ position: 'relative' }}>
    <div className={(loading && midas.loading) || ''}>
      <div style={loading ? { color: 'rgba(0,0,0,0.3)' } : {}}>{children}</div>
    </div>
  </div>
)

LoaderOverlay.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

LoaderOverlay.defaultProps = {
  loading: false,
}

export default LoaderOverlay
